module.exports = __WEBPACK_EXTERNAL_MODULE_97__;


//////////////////
// WEBPACK FOOTER
// external "jquery"
// module id = 97
// module chunks = 0